import posthog from 'posthog-js';

export const identifyUser = (userData: any) => {
  console.log('PostHog: Identifying user with data:', userData);
  
  // Use name as distinct_id since it's available in the user data
  const distinctId = userData.name;
  console.log('PostHog: Using distinct ID:', distinctId);
  
  // Set person properties - only essential user info
  posthog.identify(distinctId, {
    email: userData.email,
    name: userData.name,
  });
  
  console.log('PostHog: User identification complete');
};

export const resetUser = () => {
  console.log('PostHog: Resetting user');
  posthog.reset();
};

export const captureEvent = (eventName: string, properties?: Record<string, any>) => {
  console.log('PostHog: Capturing event:', eventName, properties);
  posthog.capture(eventName, properties);
}; 